module.exports = "<!-- TO BE REMOVED -->\n<div class=\"modal-header\">\n    <h2 class=\"modal-title text-center\"> </h2>\n</div>\n";